import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { RUN_LOGS_DELETE } from "./gql";

const useDeleteRunLogs = createDefaultMutationHook(RUN_LOGS_DELETE);

export default useDeleteRunLogs;
